var l = /* @__PURE__ */ ((r) => (r.PRIMARY = "primary", r.SECONDARY = "secondary", r.LINK = "link", r.WARNING = "warning", r.LINK_UNDERLINED = "link-underlined", r.GHOST = "ghost", r))(l || {}), L = /* @__PURE__ */ ((r) => (r.DEFAULT = "default", r.SMALL = "small", r.TINY = "tiny", r))(L || {}), N = /* @__PURE__ */ ((r) => (r.FULL_WIDTH = "full-width", r.AUTO = "auto", r))(N || {});
export {
  L as ButtonSizes,
  l as ButtonVariants,
  N as ButtonWidths
};
